import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F8916LimService {

  constructor(private http: HttpClient) { }

  save8916Form(baseUrl: string, saveData: any[], globalService: any, filterParams: any = {}, rowData: any = {}): Observable<any> {
    // Use rowData parameter instead of extracting from saveData

    const jsonSettings = {
      "tax_year": rowData.TAX_YEAR || filterParams.tax_year || '',
      "scenario": rowData.SCENARIO || filterParams.scenario || "",
      "jcd_key": rowData.JCD_KEY || filterParams.jcd_key || "",
      "combination_key": rowData.COMBINATION_KEY || filterParams.combination_key || '',
      "trans_type_key": saveData[0]?.editrows?.[0]?.[0]?.trans_type_key || '',
      "scenarioCode": rowData.SCENARIO_CODE || filterParams.scenarioCode || rowData.SCENARIO || filterParams.scenario || "",
      "is_issue_key_enabled": "N"
    };

    // Use filter parameters passed from component (replaces workspaceFactory.activeScreen.filters.getFilterParams())

    // Build payload structure exactly like in original AngularJS
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ jsonObj: JSON.stringify(saveData) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.process_name = 'F1120_8916';
    params.combination_key = rowData.COMBINATION_KEY;
    params.trans_type_key = jsonSettings.trans_type_key;

    // Add checkLockedbj for lock checking
    const checkLockedbj = [{
      "leid": rowData.LEID || rowData.SOURCE_LEID || "",
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY || "1"),
      "combination_key": String(rowData.COMBINATION_KEY || filterParams.combination_key || "")
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Convert params to URLSearchParams for form-urlencoded format (like AngularJS)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(
      `${baseUrl}/saveJsonObject?action_code=z9frws`,
      urlEncoded.toString(),
      httpOptions
    );
  }
} 